var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('delete-statements'),_vm._v(" "),_c('clear-all')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('delete-logs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }